import { withStyles } from '@material-ui/styles';

import IntegrationRequestWidget from './IntegrationRequestWidget';
import styles from './styles';

export default withStyles(styles)(IntegrationRequestWidget);
